import React from "react";
import "./SkipButtons.css";

const SkipBackwards = ({ onSkipBackward }) => {
  return (
    <div className="controls">
      <button onClick={onSkipBackward} className="wind">
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1202 1.49213L10.7938 8.98566L18.2874 13.312M5.53521 18.5554C5.01784 21.8004 5.62423 25.1249 7.254 27.9783C8.88376 30.8318 11.4392 33.043 14.4971 34.246C17.555 35.4491 20.9321 35.5717 24.0692 34.5935C27.2064 33.6154 29.9154 31.5952 31.7477 28.8675C33.5801 26.1397 34.4259 22.868 34.1452 19.5939C33.8645 16.3199 32.474 13.2399 30.2041 10.8639C27.9341 8.48785 24.9207 6.95833 21.6629 6.52852C18.4051 6.09871 15.0981 6.7944 12.2896 8.50041"
            stroke="#A0A3B1"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6267 25.5083H15.2087V18.6587L13.1169 19.3735V18.1724L16.4451 16.9478H16.6267V25.5083ZM19.9724 21.2778L20.4353 16.9771H25.0173V18.2075H21.6189L21.3845 20.2466C21.7791 20.02 22.2244 19.9067 22.7205 19.9067C23.533 19.9067 24.1638 20.1665 24.613 20.686C25.0662 21.2056 25.2927 21.9048 25.2927 22.7837C25.2927 23.6509 25.0427 24.3423 24.5427 24.8579C24.0427 25.3696 23.3572 25.6255 22.4861 25.6255C21.7048 25.6255 21.0564 25.4048 20.5408 24.9634C20.0291 24.5181 19.7517 23.9321 19.7087 23.2056H21.0857C21.1404 23.6196 21.2888 23.938 21.531 24.1606C21.7732 24.3794 22.0896 24.4888 22.4802 24.4888C22.9177 24.4888 23.2576 24.3325 23.4998 24.02C23.7458 23.7075 23.8689 23.2817 23.8689 22.7427C23.8689 22.2231 23.7341 21.813 23.4646 21.5122C23.1951 21.2075 22.824 21.0552 22.3513 21.0552C22.0935 21.0552 21.8748 21.0903 21.6951 21.1606C21.5154 21.2271 21.3201 21.3599 21.1091 21.5591L19.9724 21.2778Z"
            fill="#A0A3B1"
          />
        </svg>
      </button>
    </div>
  );
};

export default SkipBackwards;
